module.exports = __webpack_public_path__ + "static/media/discontrol024.83f58199.jpg";